'use strict';

import NotificationsList from './notifications.list.ctrl';
import NotificationInfo from './notifications.info.ctrl';
import NotificationGroups from './groups/notificationGroups';
import EditNotificationGroups from './groups/edit/editNotificationGroups';

export default angular
  .module('main.notifications', [
    NotificationsList,
    NotificationInfo,
    NotificationGroups,
    EditNotificationGroups,
  ])
  .name;
